import MuiTimelineConnector from "@material-ui/lab/TimelineConnector";
import MuiTimelineContent from "@material-ui/lab/TimelineContent";
import MuiTimelineDot from "@material-ui/lab/TimelineDot";
import MuiTimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import clsx from "clsx";
import { COLORS } from "constants/colors";
import styled from "styled-components";
import React from "react";
import { AddressPickup } from "domains/Tasks/details/styles";
import { Address } from "generated/graphql";
import { formatAddress } from "../utils";

export const TimelineItem = styled(MuiTimelineItem)`
  min-height: 40px;
  margin-left: 10px;
  &.dot {
    min-height: 20px;
  }
  :before {
    content: none;
  }
`;

export const TimelineContent = styled(MuiTimelineContent)`
  color: #707070;
  font-size: 11px;
  font-weight: 900;
  height: fit-content;
  margin-left: 22px;
  padding: 0 5px;
  position: absolute;
  top: 2px;
`;

export const TimelineConnector = styled(MuiTimelineConnector)`
  width: 1px;
  &.dot {
    margin-left: 7px;
  }
`;

export const TimelineDot = styled(MuiTimelineDot)`
  align-items: center;
  background-color: transparent;
  box-shadow: none;
  color: ${COLORS.primary} !important;
  display: flex;
  font-size: 10px;
  font-weight: bold;
  justify-content: center;
  height: 18px;
  margin: 0;
  width: 18px;
  border-color: ${COLORS.primary} !important;
  border-width: 1px;

  &.dot {
    height: 5px;
    margin-left: 7px;
    padding: 0;
    width: 4.5px;
  }
`;
interface LocationProps {
  address?: Address;
}
const Location = ({ address }: LocationProps) => {
  return (
    <>
      <TimelineItem className="startPoint">
        <TimelineSeparator>
          <TimelineDot>L</TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <AddressPickup>{address?.address}</AddressPickup>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem className="dot">
        <TimelineSeparator>
          <TimelineDot className={clsx("dot")} />
        </TimelineSeparator>
        <TimelineContent />
      </TimelineItem>
    </>
  );
};

export default Location;
